import useOperationSummary from '../../Hooks/useOperationSummary';
import useApplication, { ApplicationSummary } from './useApplication';
import {
  OperationSummaryError,
  OperationSummaryParams
} from '../../Components/types';

interface UseApplicationsSummaryReturn {
  loading: boolean;
  applications: ApplicationSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadApplications: () => Promise<void>;
  errors?: OperationSummaryError | null;
}

const useApplicationsSummary = (
  params?: OperationSummaryParams
): UseApplicationsSummaryReturn => {
  const { getSummaryApplications } = useApplication();

  const {
    loading,
    items: applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadApplications,
    errors
  } = useOperationSummary<ApplicationSummary>(
    'applicationsSummary',
    getSummaryApplications,
    params,
    'applicationsSummary'
  );

  return {
    loading,
    applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadApplications,
    errors
  };
};

export default useApplicationsSummary;
